import { useContext, createContext } from "react";

export const RepliesContext = createContext(null);

export function useRepliesContext() {
  return useContext(RepliesContext);
}
